const SET_CAP_IS_VISIBLE = 'SET_CAP_IS_VISIBLE';

export { SET_CAP_IS_VISIBLE };



// WEBPACK FOOTER //
// ./src/containers/Inputs/CAP/constants.js